import { render, staticRenderFns } from "./realGroup.vue?vue&type=template&id=e3e164e8&"
import script from "./realGroup.vue?vue&type=script&lang=ts&"
export * from "./realGroup.vue?vue&type=script&lang=ts&"
import style0 from "./realGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports